import {
	FEEDBACK_CONTEXT_FIELD_ID,
	FEEDBACK_GROUP_ID,
	DID_NOT_RESPOND_VALUE,
} from './constants.tsx';

export function buildAdditionalFields(migrationOption: string = DID_NOT_RESPOND_VALUE) {
	return [
		{
			id: FEEDBACK_CONTEXT_FIELD_ID,
			value: `feedback-group-id: ${FEEDBACK_GROUP_ID} \n selected-migrate-option: ${migrationOption}`,
		},
	];
}
